<template>
    <div class="rightContent">
        <div class="rightTitle clear">
            <div class="colorLump"></div>
            <div class="title">修改基本信息</div>
        </div>
        <div class="main">
            <div class="rightBox">
                <el-form :model="query" :rules="queryRules" ref="queryFormRef">
                    <el-form-item label="联系人" required prop="contact">
                        <el-input v-model="query.contact" placeholder="请输入联系人姓名" />
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="query.email" placeholder="请输入邮箱地址" />
                    </el-form-item>
                    <el-form-item label="机构logo" required prop="logo" class="logoPic">
                        <ImageUpload @handleUploadSuccess="uploadAvatarSuccess($event,'logo')" :url="query.logo"></ImageUpload>
                    </el-form-item>
                    <el-form-item label="机构全称" required prop="name">
                        <el-input v-model="query.name" placeholder="请输入机构全称" />
                    </el-form-item>
                    <div class="flex">
                        <el-form-item label="机构地址" required prop="province">
                            <el-select v-model="query.provinceName" placeholder="省份" style="width: 150px;"
                                @change="areaChange($event, 'pro')">
                                <el-option v-for="(item,k) in drownArray.province" :key="item.regionId"
                                    :label="item.regionName"
                                    :value="k"
                                    />
                            </el-select>
                        </el-form-item>
                        <el-form-item required prop="cityName">
                            <el-select v-model="query.cityName" placeholder="城市" style="width: 150px;"
                                @change="areaChange($event, 'city')">
                                <el-option v-for="(item,k) in drownArray.city" :key="item.regionId"
                                    :label="item.regionName"
                                    :value="k" />
                            </el-select>
                        </el-form-item>
                        <el-form-item required prop="areaName" v-if="query.areaName">
                            <el-select v-model="query.areaName" placeholder="区域" style="width: 150px;"
                                @change="areaChange($event, 'area')">
                                <el-option v-for="(item,k) in drownArray.area" :key="item.regionId"
                                    :label="item.regionName"
                                    :value="k" />
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item prop="address" style="margin-left:120px">
                        <el-input v-model="query.address" placeholder="请输入详细信息" />
                    </el-form-item>
                    <el-form-item label="机构简介" required prop="remarks">
                        <el-input :rows="6" type="textarea" v-model="query.remarks" placeholder="请输入机构简介"
                            maxlength="140" show-word-limit />
                    </el-form-item>
                    <el-form-item label="机构介绍" required prop="info">
                        <el-input :rows="6" type="textarea" v-model="query.info" placeholder="请输入机构介绍"
                            maxlength="500" show-word-limit />
                    </el-form-item>
                    <el-form-item :label="labelData.FirstUploadLab" required prop="cerOneImg" class="logoPic">
                        <ImageUpload  @handleUploadSuccess="uploadAvatarSuccess($event,'cerOneImg')" :url="query.cerOneImg"></ImageUpload>
                    </el-form-item>
                    <el-form-item label="有效期至" required prop="cerOneImgDate">
                        <el-date-picker
                            v-model="query.cerOneImgDate"
                            type="date"
                            placeholder="选择日期"
                            :disabled="labelData.cerOneImgDateDisable"
                        />
                    </el-form-item>
                    <el-form-item :label="labelData.LastUploadLab" prop="otherCer" class="logoPic" :required="labelData.zzIsRequired" v-if="query.type == '公司' || query.type == '民办非企业'">
                        <ImageUpload  @handleUploadSuccess="uploadAvatarSuccess($event,'otherCer')" :url="query.otherCer"></ImageUpload>
                    </el-form-item>
                    <el-form-item label="有效期至（选填）" :required="labelData.zzyxqIsRequired" prop="otherCerDate" v-if="query.type == '公司' || query.type == '民办非企业'">
                        <el-date-picker
                            v-model="query.otherCerDate"
                            type="date"
                            placeholder="选择日期"
                        />
                    </el-form-item>
                    <el-form-item label="业务范围" required prop="businessscope">
                        <el-input :rows="6" type="textarea" v-model="query.businessscope" placeholder="请输入业务范围" />
                    </el-form-item>
                    <button type="button"  class="el-button nextStepBtn el-button--primary"  @click="bindRdit(queryFormRef)">
                        <span>保存</span>
                    </button>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script setup>
 import { ref, reactive,getCurrentInstance } from 'vue'
 import ImageUpload from "../../components/ImageUpload/index.vue"
 import { registerSelectInfo ,registerRegionInfo} from "../../server/jigou/org";
 import { getJgInfo,updateorg } from '../../server/jigou/orgCenter'
 import { useRouter } from "vue-router";

 const query = reactive({
    id:'',
    contact:'',
    email: '',
    logo: '',
    name:'',
    province:'',
    provinceName:'',
    city:'',
    cityName:'',
    area:'',
    areaName:'',
    address:'',
    remarks:'',
    info:'',
    cerOneImg:'',
    cerOneImgDate:'',
    otherCer:'',
    otherCerDate:'',
    businessscope:'',
    type:''
 })
 const labelData = reactive({
    FirstUploadLab: '营业执照',
    LastUploadLab:'其他资质（选填）',
    zzIsRequired: false,
    zzyxqIsRequired: false,
    islongtimeStatus: true,
    cerOneImgDateDisable: false
})
 const { proxy } = getCurrentInstance()
 const queryFormRef = ref(null)
 const queryRules = reactive({
    contact: [{ required: true, message: '请输入联系人', trigger: "blur" }],
    logo: [{ required: true, message: '请上传logo', trigger: "blur" }],
    name: [{ required: true, message: '请输入机构全称', trigger: "blur", }],
    province: [{ required: true, message: '请选择省份', trigger: "change" }],
    city: [{ required: true, message: '请选择城市', trigger: "change" }],
    area: [{ required: true, message: '请选择区域', trigger: "change" }],
    address: [{ required: true, message: '请输入详细地址', trigger: "blur" }],
    remark: [{ required: true, message: '请输入机构简介', trigger: "blur" }],
    info: [{ required: true, message: '请输入机构介绍', trigger: "blur" }],
    cerOneImg: [{ required: true, message: '请上传'+labelData.FirstUploadLab, trigger: "blur" }],
    cerOneImgDate: [{ required: true, message: '请选择有效期至', trigger: "change"}],
    businessscope: [{ required: true, message: '请输入业务范围', trigger: "blur" }],
    otherCer: [{ required: labelData.zzIsRequired, message: '请上传'+labelData.LastUploadLab, trigger: "blur" }],
    otherCerDate: [{ required: labelData.zzyxqIsRequired, message: '请选择有效期至', trigger: "change" }],
 })
 const router = useRouter()

const drownArray = reactive({
    province: [],
    city: [],
    area: '',
})
//获取所有下拉信息
async function getDownArrays() {
    const res = await registerSelectInfo();
    drownArray.province = res.province
};
//省市联动变化
function areaChange(val, type) {
    if (type == 'pro') {
        query.provinceName = drownArray.province[val].regionName
        query.province = drownArray.province[val].regionId
        registerRegionInfo({ id: query.province }).then(rescity => {
            drownArray.city = rescity
            query.city = drownArray.city[0].regionId
            query.cityName = drownArray.city[0].regionName
            query.area = ''
            query.areaName = ''
        })
    }
    if (type == 'city') {
        query.city = drownArray.city[val].regionId
        query.cityName = drownArray.city[val].regionName

        registerRegionInfo({ id: query.city }).then(resArea => {
            drownArray.area = resArea
            if( drownArray.area.length ){
                query.area = drownArray.area[0].regionId
                query.areaName = drownArray.area[0].regionName
            }
        })
    }
    if (type == 'area') {
        query.area = drownArray.area[val].regionId
        query.areaName = drownArray.area[val].regionName
    }
}
getDownArrays();
async function getInfo(){
    let res = await getJgInfo()
    query.id = res.orgInfo.id
    query.contact = res.orgInfo.contact
    query.email = res.orgInfo.email
    query.logo = res.orgInfo.logo
    query.name = res.orgInfo.name
    query.provinceName = res.orgInfo.provinceName
    query.province = res.orgInfo.province
    query.cityName = res.orgInfo.cityName
    query.city = res.orgInfo.city
    query.areaName = res.orgInfo.areaName
    query.area = res.orgInfo.area
    query.address = res.orgInfo.address
    query.remarks = res.orgInfo.remarks
    query.info = res.orgInfo.info
    query.cerOneImg = res.orgInfo.cerOneImg
    query.cerOneImgDate = res.orgInfo.cerOneImgDate
    query.otherCer = res.orgInfo.otherCer
    query.otherCerDate = res.orgInfo.otherCerDate
    query.businessscope = res.orgInfo.businessscope
    query.type = res.orgInfo.type

    if( res.orgInfo.type == '民办非企业' ){
        labelData.FirstUploadLab = '民办非企业单位登记证书'
        labelData.LastUploadLab = '中华人民共和国民办学校办学许可证'
        labelData.zzIsRequired = true
        labelData.zzyxqIsRequired = true
        labelData.islongtimeStatus = true
    }
    if( res.orgInfo.type == '公司' ){
        labelData.FirstUploadLab = '营业执照'
        labelData.LastUploadLab = '其他资质（选填）'
        labelData.zzIsRequired = false
        labelData.zzyxqIsRequired = false
        labelData.islongtimeStatus = false
    }
    if( res.orgInfo.type == '事业单位' ){
        labelData.FirstUploadLab = '事业单位法人证书'
        labelData.LastUploadLab = '其他资质（选填）'
        labelData.zzIsRequired = false
        labelData.zzyxqIsRequired = false
        labelData.islongtimeStatus = false
    }
    if( res.orgInfo.type == '社会团体' ){
        labelData.FirstUploadLab = '社会团体法人登记证书'
        labelData.LastUploadLab = '其他资质（选填）'
        labelData.zzIsRequired = false
        labelData.zzyxqIsRequired = false
        labelData.islongtimeStatus = false
    }
}
getInfo()
// var a= await 
//上传图片回调
function uploadAvatarSuccess(cbResult,type){
    console.log('result',cbResult,type);
    if( type == 'logo' ){
        query.logo = cbResult
    }
    if(type == 'cerOneImg'){
        query.cerOneImg = cbResult
    }
    if( type == 'otherCer' ){
        query.otherCer = cbResult
    }
    
}
//提交修改
async function bindRdit(formEl){
    formEl.validate(async (valid, fields) => {
        if (!valid) {
            return;
        }
    })
    console.log(query);
    let res = await updateorg(query)
    if(res != false){
        proxy.$modal.msgSuccess("信息修改成功");
        router.push({path:'jbxx'})
    }
   
}
</script>
<style scoped>
.codeInput,.el-input{
    width: 200px;
}
.el-form-item >>>.el-form-item__label{
    width: 120px !important;justify-content: flex-start;
}
</style>